import { Step, StepLabel, Stepper, StepperProps } from '@mui/material'
import React from 'react'

interface AppStepperProps extends Omit<StepperProps, 'children'> {
  steps: Array<{ label: React.ReactNode }>
}

const AppStepper: React.FC<AppStepperProps> = ({ steps, ...stepperProps }) => {
  return (
    <Stepper alternativeLabel {...stepperProps}>
      {steps.map((s) => (
        <Step key={s.label as string}>
          <StepLabel>{s.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default AppStepper
